import PostTemplate from "../PostTemplate";
import axios from "axios";
import { SetStateAction, useEffect, useState } from 'react';
import '../../assets/css/Post.css'
import Row from 'react-bootstrap/Row';
import PaginationButton from "../pagination/PaginationButton";
import Col from 'react-bootstrap/Col';
import LoadingSpinner from "../spinner/LoadingSpinner";
import { axiosInstance } from "../../utils";

const Post = () => {
    const [posts, setPosts] = useState<any[]>([]);
    const [loading, setLoading] = useState(false);
    //pagination state 
    const [currentPage, setCurrentPage] = useState(1);
    const [postPerPage, setPostPerPage] = useState(6);
    console.log(posts);

    const fetchPost = async () => {
        setLoading(true);
        const response = await axiosInstance.get('/posts');
        setPosts(response.data);
        setLoading(false);
    }

    useEffect(() => {
        fetchPost();
    },[])

    //current Post 
    const indexOfLastPost = currentPage * postPerPage;
    const indexOfFirstPost = indexOfLastPost - postPerPage;
    const currentPosts = posts.slice(indexOfFirstPost, indexOfLastPost);

    console.log(currentPosts);

    //change page 
    const paginate = (pageNumber: SetStateAction<number>) => setCurrentPage(pageNumber);


  return (
    <div className='controll__footer'>
            <div className="wrapper">
        <div className="main__wrapper">
            {loading ? <LoadingSpinner /> :
            <Row xs={1} md={2} lg={3} className="g-4">
                {currentPosts.map(post => {
                        return (
                            <PostTemplate 
                                id={post._id}
                                title={post.title} 
                                photo={post.photo}
                                desc={post.desc} 
                                author={post.author} 
                                createdAt={post.createdAt} 
                                key={post._id}
                            />
                        )
                    })}
            </Row>}
            {postPerPage > 6 &&
            <Col xs={12} className="pagination__wrapper">
                <PaginationButton 
                    postsPerPage={postPerPage} 
                    totalPosts={posts.length}
                    paginate={paginate}
                />
            </Col>}
        </div>
    </div>
    </div>
  )
}

export default Post
